import type { Semaforo } from '@/lib/tipos';

/**
 * As cores do semáforo de ocupação — UMA definição para a aplicação inteira.
 *
 * POR QUE AQUI, e não em cada tela
 * --------------------------------
 * Havia duas cópias idênticas desta tabela, uma no mapa 3D e outra no rack de
 * movimentação, e a segunda trazia o comentário "mesmas cores do mapa". Era
 * verdade por acaso: nada obrigava. Bastava alguém ajustar um tom num lado
 * para o operador ver a MESMA posição em duas cores em telas vizinhas — e
 * quem confere estoque decide pela cor antes de ler o número.
 *
 * O VAZIO É AZUL CLARO, e isso não é decoração
 * --------------------------------------------
 * Vaga livre era cinza (#e2e8f0), quase igual ao "sem medida" (#94a3b8) e
 * quase igual ao fundo da própria tela. As três coisas que mais se confundem
 * num mapa de CD são exatamente essas: o que está vazio, o que não dá para
 * medir e o que não é vaga. Azul tira o vazio dessa confusão e é a única cor
 * que não briga com verde/âmbar/vermelho, que já estão ocupados pela escala
 * de ocupação.
 *
 * Vazio é ESPAÇO DISPONÍVEL — a informação que a operação procura quando abre
 * o mapa para alocar. Merece cor própria, não a ausência de cor.
 */
export const SEMCOR: Record<Semaforo, string> = {
  vazio: '#7dd3fc', // sky-300 — espaço livre, o que se procura para alocar
  baixo: '#22c55e',
  medio: '#f59e0b',
  alto: '#dc2626',
  sem_medida: '#94a3b8',
  divergencia: '#dc2626',
};

/**
 * Matiz do vazio na planta do CD, que pinta por gradiente e não por tabela.
 *
 * A planta monta a cor com `hsl()` a partir do percentual, então não consome
 * o hex acima — mas precisa concordar com ele, senão a rua vazia aparece azul
 * num nível de zoom e cinza no outro.
 */
export const MATIZ_VAZIO = 199;
export const SATURACAO_VAZIO = 80;
